import { Trans } from '@lingui/macro';
import { NavigateBefore, NavigateNext } from '@mui/icons-material';
import { Button, ButtonGroup, Grid, Typography, Paper } from '@mui/material';
import { DateTime } from 'luxon';
import { Fragment, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { employeeService } from 'services';

const TopCalendar = () => {
  const [pivot, setPivot] = useState(0);
  const pivotWeek = DateTime.now().plus({ week: pivot });
  const workingDays = Array.from({ length: 5 }).map((_, index) => pivotWeek.startOf('week').plus({ day: index }));

  const monthSearch = useMemo(() => {
    return {
      meetingDateFrom: pivotWeek.startOf('month').toISO(),
      meetingDateTo: pivotWeek.endOf('month').toISO(),
    };
  }, [pivotWeek]);

  const weekSearch = useMemo(() => {
    return {
      meetingDateFrom: pivotWeek.startOf('week').toISO(),
      meetingDateTo: pivotWeek.endOf('week').toISO(),
    };
  }, [pivotWeek]);

  const { data: monthly } = useQuery(
    ['employeeService.fetchEmployees', { status: 'AGREED_TO_MEET', ...monthSearch }],
    () => employeeService.fetchEmployees({ status: 'AGREED_TO_MEET', ...monthSearch }),
  );
  const { data: weekly } = useQuery(
    ['employeeService.fetchEmployees', { status: 'AGREED_TO_MEET', ...weekSearch }],
    () => employeeService.fetchEmployees({ status: 'AGREED_TO_MEET', ...weekSearch, size: 100 }),
  );

  return (
    <Paper>
      <div className='bg-primary-main text-white rounded-t px-3 py-2'>
        <Typography variant='h4'>
          <Trans>LỊCH TẤT TOÁN & THU PHÍ DỊCH VỤ</Trans>
        </Typography>
      </div>
      <div className='p-3'>
        <Grid container columnSpacing={4} rowSpacing={1} className='mb-6'>
          <Grid item xl={10}>
            <div className='flex items-start'>
              <Grid container className='text-center'>
                <Grid item sm={2} className='relative bg-primary-light text-white border p-2'>
                  <div>
                    <Trans>WEEK</Trans> {pivotWeek.weekNumber}
                  </div>
                  <div>{pivotWeek.year}</div>
                </Grid>
                {workingDays.map((today, index) => (
                  <Grid item key={index} sm={2} className='bg-primary-light text-white border p-2'>
                    <div>{today.weekdayLong.toUpperCase()}</div>
                    <div>{today.toFormat('dd/MM/yyyy')}</div>
                  </Grid>
                ))}

                <Grid item sm={2} className='border p-2'>
                  <ButtonGroup variant='contained' size='small'>
                    <Button onClick={() => setPivot((v) => v - 1)}>
                      <NavigateBefore />
                    </Button>
                    <Button disabled={pivot === 0} onClick={() => setPivot(0)}>
                      <Trans>TODAY</Trans>
                    </Button>
                    <Button onClick={() => setPivot((v) => v + 1)}>
                      <NavigateNext />
                    </Button>
                  </ButtonGroup>
                </Grid>
                {workingDays.map((today, index) => {
                  const { data: items = [] } = weekly ?? {};
                  const meetings = items.filter((item) =>
                    DateTime.fromISO(item.meetingDate).startOf('day').equals(today),
                  );
                  return (
                    <Grid item key={index} sm={2} className='border p-2'>
                      <Typography variant='h4' className='mb-2'>
                        {meetings.length}
                      </Typography>
                      <Grid container>
                        {meetings.map((client, index) => (
                          <Fragment key={index}>
                            <Grid item sm={4} className='bg-gray-300 border-b p-1'>
                              {DateTime.fromISO(client.meetingDate).toFormat('hh:mm a')}
                            </Grid>
                            <Grid item sm={8} className='bg-gray-200 border-b p-1'>
                              {client.name}
                            </Grid>
                          </Fragment>
                        ))}
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </div>
          </Grid>
          <Grid item sm={12} xl={2}>
            <Grid container className='text-center w-60 ml-2'>
              <Grid item sm={12} className='bg-primary-light text-white border p-2'>
                <Trans>TỔNG GIÁ TRỊ TẤT TOÁN TRONG TUẦN (VND) </Trans>
              </Grid>
              <Grid item sm={12} className='border p-2'>
                <Typography variant='h4' className='mb-2'>
                  {weekly?.paginate.totalRecord ?? 0}
                </Typography>
              </Grid>
              <Grid item sm={12} className='bg-primary-light text-white border p-2'>
                <Trans>TỔNG PHÍ DỊCH VỤ PHẢI THU TRONG TUẦN (VND) </Trans>
              </Grid>
              <Grid item sm={12} className='border p-2'>
                <Typography variant='h4' className='mb-2'>
                  {monthly?.paginate.totalRecord ?? 0}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
};

export default TopCalendar;
